/**
 * Why the discussion could not be read, said accurately.
 *
 * The first version of this assumed one cause and asserted it: "You do not have access to
 * it." The actual first failure in production was a missing collection-group index, and
 * the person who hit it was the one who had written the comment — so the message sent them
 * looking at permissions for a problem that was nothing to do with them.
 *
 * A message that names a cause has to have checked it. Firestore says which it is on the
 * error; anything unrecognised is reported as what is actually known, which is that the
 * read failed.
 */
export function whyNoDiscussion(error: unknown): string {
  const code = (error as { code?: string } | null)?.code
  if (code === 'permission-denied') return 'Your role cannot read it.'
  if (code === 'failed-precondition') {
    return 'The database is still building the index it needs. Try again in a few minutes.'
  }
  if (code === 'unavailable') return 'The database could not be reached.'
  return 'It could not be read. Everything else in the file is complete.'
}
